const PADDING = 32;
const ANIMATION_SPEED = 300;
const updateSelectedButton = (activeButton, selectedButton) => {
  activeButton & activeButton.classList.remove('active');
  selectedButton && selectedButton.classList.add('active');
};

const setParentHeight = (el, height) => {
  el.style.height = `${height}px`;
};

const showElement = (el) => {
  el.style.display = 'block';
  el.classList.add('is-visible');
};

const hideElement = (el) => {
  el.style.display = 'none';
  setTimeout(() => el.classList.remove('is-visible'), 10);
};

const showTabGroup = (button, target) => {
  let containerHeight = 0;
  // Find the closest FAQs block container to scope queries
  const faqsBlock = button.closest('.faqs-block');
  if (!faqsBlock) return;
  
  const selectors = {
    $group: faqsBlock.querySelectorAll('div.is-visible[data-faqs-group]'),
    $targetedGroup: faqsBlock.querySelectorAll(`[data-faqs-group="${target}"]`),
    $parent: faqsBlock.querySelector('[data-faqs-list]'),
    $activeButton: faqsBlock.querySelector('.faqs-block__tab-toggle.active'),
  };

  if (button) {
    updateSelectedButton(selectors.$activeButton, button);
  }

  selectors.$group.forEach((el) => hideElement(el));
  selectors.$targetedGroup.forEach((el) => {
    showElement(el);
    containerHeight += el.offsetHeight;
  });

  setTimeout(
    () => setParentHeight(selectors.$parent, containerHeight),
    ANIMATION_SPEED
  );
};

const resizeParentContainer = (accordionItem) => {
  // Find the closest FAQs block container to scope queries
  const faqsBlock = accordionItem.closest('.faqs-block');
  if (!faqsBlock) return;
  
  let newHeight = 0;
  const selectors = {
    $parent: faqsBlock.querySelector('[data-faqs-list]'),
    $children: faqsBlock.querySelectorAll('.accordion__container.is-visible'),
  };
  selectors.$children.forEach((el) => (newHeight += el.offsetHeight));
  newHeight += PADDING;
  setParentHeight(selectors.$parent, newHeight);
};

const initFaqsBlock = () => {
  // Find all FAQs blocks and initialize each one separately
  const faqsBlocks = document.querySelectorAll('.js-enable-faq-tabs');
  
  faqsBlocks.forEach((faqsBlock) => {
    const buttons = faqsBlock.querySelectorAll('[data-target-faqs-group]');
    const accordionItems = faqsBlock.querySelectorAll('.accordion__item');

    buttons.forEach((btn) =>
      btn.addEventListener('click', () => {
        showTabGroup(btn, btn.dataset.targetFaqsGroup);
      })
    );

    accordionItems.forEach((item) =>
      item.addEventListener('click', () => {
        setTimeout(() => resizeParentContainer(item), ANIMATION_SPEED);
      })
    );
  });
};

export default () => {
  const enableFAQsModules = document.querySelectorAll('.js-enable-faq-tabs');
  if (!enableFAQsModules || enableFAQsModules.length === 0) {
    return false;
  }
  // Use DOMContentLoaded or run immediately if DOM is already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqsBlock);
  } else {
    initFaqsBlock();
  }
};
